import TaskAssigned from './TaskAssigned';
export default TaskAssigned;


// WEBPACK FOOTER //
// ./src/pages/TaskAssigned/index.js